const sliderDetail = document.querySelector('.js-slider-swiper-detail');

if (sliderDetail) {
	const swiper = new Swiper(sliderDetail, {
		effect: "fade",
		fadeEffect: {
			crossFade: true
		},
		loop: true,
		speed: 1000,
		navigation: {
			nextEl: '.js-swiper-button-next',
			prevEl: '.js-swiper-button-prev',
		}
	});
}
